import styled from "styled-components";


export const StyledContent = styled.div`
   @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;800&display=swap');
 background: #F4F6FC;
 height: 500px;
  padding: 0px 25px;
/*   */

 
.content__space{
 background: #F4F6FC;
margin-right: 10px;
padding: 0 50px;

 /* second image content */
 .Content1{
    padding: 0 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    /* justify-content: space-between; */

    .content__left{
       width: 60%;
       word-wrap: break-word;
         margin-top: -20px;
        div{
          padding-bottom: 70px;
        }
       .content__title1{
            color: #080055;
            line-height: 60px;
            font-weight: 800px;
            font-size: 43px;
            padding: 5px 0px;
            margin-bottom: 10px;
        }
        .content__desc{
        font-weight: 400;
        font-size: 14px;
        line-height: 25px;
        color: #18191F;
                }
    }

    .Content__image1{
    
        div{
            position: relative;
            top: 0px;
            .content_below{
                position: relative;
                top: 0;
                left: 130px;
               margin-right: 90px;

                img{
                        width: 338px;
                    }
            }
            
            .content_img{
               
                position: absolute;
                top: 0px;
                right:20px;
                width: 470px;
            }
        
        }
          
    }

 }
}

@media (max-width: 992px) {
    padding: 0px 25px;
    margin-top:20px;
    min-width: 900px;
    .content__space{
     
              
        .Content1{
             display: flex; 
            gap: 10px;
           justify-content: space-between;
            .content__left{
                
            
               div{
                padding-top:20px;
                padding-bottom:30px;
                padding-right: 30px;
                word-wrap: break-word;
                    .content__desc{
                       
                    }

               }
            } 

           .content__image1{

             div{
                .content_img{
                    width:300px;
                }
                 .content__below{
                    
                   }
                 
                 }
           }

        }

    }
}

`